import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FaqSectionComponent } from './faq-section.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { SharedModule } from '../shared/shared.module'
import { NgxJsonLdModule } from 'ngx-json-ld'
import { RichsnipetService } from 'dmmp-services'

@NgModule({
  declarations: [FaqSectionComponent],
  imports: [CommonModule, NgbModule, SharedModule, NgxJsonLdModule],
  exports: [FaqSectionComponent],
  providers: [RichsnipetService],
})
export class FaqSectionModule {}
